import { useEffect } from "react";
import { SITE_URL, ORG_ID, CYRUS_ID } from "../../data/entityGraph";

/**
 * BookSchema - "Authentic Momentum" book.
 *
 * Injects a Book node with a scoped @id of /book#book, mounted on
 * /book ONLY. Previously this lived inside ProductSchema.jsx and
 * was injected on /, /start-here, and /book simultaneously - which
 * is exactly what caused Google's Merchant Listing duplicate-field
 * detection on the Personal Action Plan. Splitting Book + Product
 * into route-scoped components removes the cross-route merge.
 */
const BOOK_LD = {
  "@context": "https://schema.org",
  "@type": "Book",
  "@id": `${SITE_URL}/book#book`,
  name: "Authentic Momentum",
  author: { "@id": CYRUS_ID },
  bookFormat: "https://schema.org/EBook",
  inLanguage: "en",
  publisher: { "@id": ORG_ID },
  image: `${SITE_URL}/assets/book-cover.jpg`,
  url: `${SITE_URL}/book`,
  offers: {
    "@type": "Offer",
    price: "19.99",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    url: `${SITE_URL}/book`,
  },
};

const TAG = "data-am-book-schema";

const BookSchema = () => {
  useEffect(() => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute(TAG, "authentic-momentum-book");
    el.textContent = JSON.stringify(BOOK_LD);
    document.head.appendChild(el);
    return () => {
      el.remove();
    };
  }, []);
  return null;
};

export default BookSchema;
